module.exports = __webpack_public_path__ + "static/media/cmn_title.4efa6c8b.png";